import { render, staticRenderFns } from "./observacionesModal.vue?vue&type=template&id=3f05282d&"
import script from "./observacionesModal.vue?vue&type=script&lang=js&"
export * from "./observacionesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports